import { useEffect, useState, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { resolveDestinationAfterAuthWithVendorCheck } from '@/lib/postSignupNavigation';

/** Keeps signed-in users off guest-only auth pages; respects stored signup/onboarding intent. */
export function RedirectIfAuthenticated({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);
  const [destination, setDestination] = useState<string | null>(null);

  useEffect(() => {
    if (!user) {
      setDestination(null);
      return;
    }
    let cancelled = false;
    void resolveDestinationAfterAuthWithVendorCheck(user, null)
      .then((path) => {
        if (!cancelled) setDestination(path);
      })
      .catch(() => {
        if (!cancelled) setDestination('/');
      });
    return () => {
      cancelled = true;
    };
  }, [user]);

  if (!user) return <>{children}</>;
  if (!destination) {
    return (
      <div className="py-12 text-center text-sm text-slate-500 dark:text-slate-400">Loading…</div>
    );
  }
  return <Navigate to={destination} replace />;
}
